import React from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import AlertFilterDropdown from "./AlertFilterDropdown";
import { EMPTY_ALERT_FILTERS } from "./alertFiltersUtils";

const DROPDOWNS = [
  { key: "priority", placeholder: "Prioridad", ariaLabel: "Filtrar por prioridad" },
  { key: "province", placeholder: "Provincia", ariaLabel: "Filtrar por provincia" },
  { key: "responsible", placeholder: "Responsable", ariaLabel: "Filtrar por responsable" },
  { key: "status", placeholder: "Estado", ariaLabel: "Filtrar por estado" },
];

export default function AlertFilters({
  className = "",
  search,
  onSearchChange,
  searchPlaceholder = "Buscar por comercio, CUIT, terminal, responsable, teléfono...",
  searchAriaLabel = "Buscar alertas",
  filters = EMPTY_ALERT_FILTERS,
  onFiltersChange,
  options,
  onReset,
  hasActiveFilters = false,
  hiddenKeys = [],
  children,
}) {
  return (
    <div className={`crm-alert-filters ${className}`.trim()}>
      <div className="crm-alert-filters__search">
        <FontAwesomeIcon icon={faMagnifyingGlass} />
        <input
          type="search"
          className="form-control"
          placeholder={searchPlaceholder}
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          aria-label={searchAriaLabel}
        />
      </div>

      {DROPDOWNS.filter(({ key }) => !hiddenKeys.includes(key)).map(({ key, placeholder, ariaLabel }) => (
        <AlertFilterDropdown
          key={key}
          value={filters[key]}
          options={[
            { value: "", label: placeholder },
            ...(options?.[key] || []).map((item) => ({ value: item, label: item })),
          ]}
          onChange={(value) => onFiltersChange((prev) => ({ ...prev, [key]: value }))}
          ariaLabel={ariaLabel}
        />
      ))}

      {children}

      <Button
        type="button"
        variant="light"
        className="crm-alert-filters__clear"
        onClick={onReset}
        disabled={!hasActiveFilters}
      >
        Limpiar filtros
      </Button>
    </div>
  );
}
